<template>
  <div class="headerMenu columns">
    <div class="column is-narrow menu-item" v-for="(item, index) in menuList">
      <es-dropdown v-if="item.Menus && item.Menus.length > 0" v-model="menu2[index]" :popStyle="styles.popStyle" :pushUp="'.header|#menu-product' + index" :position="index === 0 ? 'left' : 'center'" >
        <a :id="'menu-product'+ index" class="button is-primary menu-button">
          <span>{{ item.Title }}</span>
            <span class="icon is-small">
            <i class="fa fa-angle-down"></i>
          </span>
        </a>
        <div slot="content" class="menu-content">
          <div class="columns">
            <div v-for="subItem in item.Menus" class="column is-narrow dropdown-column">
              <div class="menu-dropdown-title">{{ subItem.Title }}</div>
              <template v-for="menuChildItem in subItem.Menus">
                <router-link v-if="menuChildItem.Url.indexOf('http') === -1 && menuChildItem.Url.indexOf('#newtab') === -1" class="menu-dropdown-item" v-on:click="menu2[index] = false" :to="routerUrl(menuChildItem)">{{ menuChildItem.Title }}</router-link>
                <a class="menu-dropdown-item" v-else v-on:click="openWindow(index, menuChildItem.Url)">{{menuChildItem.Title}}</a>
              </template>
            </div>
          </div>
        </div>
      </es-dropdown>
      <div v-else>
        <a :href="item.Url" target="_blank" :id="'menu-product'+ index" class="button is-primary menu-button-link"  @mouseover="isShow = true" @mouseleave="isShow = false" v-bind:class="{active: isShow}">
          <span>{{ item.Title }}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import service from '@/service'
import EsDropdown from '@/shared/components/es-dropdown-hover'
export default {
  name: 'OnlineOffice',
  components: {
    EsDropdown
  },
  data () {
    return {
      productsAndServices: [],
      supportCenter: [],
      insuranceForEveryone: [],
      menuList: [],
      isShow: false,
      menu: {
        supportCenterOpen: false,
        insuranceForEveryoneOpen: false
      },
      menu2: [false, false, false],
      styles: {
        popStyle: {
          marginTop: '17px'
        }
      },
      lang: self.$i18n ? this.$i18n.locale : 'tr'
    }
  },
  mounted () {
    var self = this
    self.getMenuItems()
  },
  methods: {
    openWindow (index, url) {
      if (url.indexOf('#newtab') !== -1) {
        return window.open(url.replace('#newtab', ''))
      } else {
        this.menu2[index] = false
        window.open(url, 'Eureko', 'width=950,height=650,resizable=yes', false)
      }
    },
    getMenuItems () {
      var self = this
      service.content.desktopMenus(self).then(function (response) {
        if (response === null) return
        self.menuList = response.data.menus
      })
    },
    routerUrl: function (menuChildItem) {
      return menuChildItem.Url.replace('Nav', 'info')
    }
  }
}
</script>
<style scoped>
.headerMenu {
  display: table !important;
  width: fit-content;
  margin: 0 auto;
  height: 44px;
}
.headerMenu .column {
  padding: 0;
}
.menu-item {
  display: table-cell;
  padding: 0 20px;
}
.menu-button, .menu-button:hover {
  padding: 0 10px;
  font-size: 0.938em;
  height: 44px;
  background-color: #004894 !important;
}
.active .menu-button {
  border-radius: 4px;
  background-color: #0d60b8 !important;
}
.menu-button-link {
  padding: 0 10px;
  font-size: 0.938em;
  height: 44px;
  background-color: #004894 !important;
}
.active{
  background-color: #0d60b8 !important;
}
.menu-content {
  padding: 30px;
}
.dropdown-column {
  padding: 0;
  margin: 15px;
  width: 170px;
}
.menu-dropdown-title, .menu-dropdown-item {
  cursor:pointer;
  font-size: 0.875em;
  letter-spacing: -0.3px;
}
.menu-dropdown-title {
  white-space: nowrap;
  font-weight: bold;
  color: #1f252b;
  padding-bottom: 15px;
}
.menu-dropdown-item {
  display: inline-block;
  padding: 7px 0 8px 0;
  font-weight: 400;
  color: #004fa3;
  width: 100%;
}
@media only screen and (max-width: 1100px) {
  .menu-button, .menu-button {
      font-size: 0.813em;
  }
  .menu-button-link, .menu-button-link {
      font-size: 0.813em;
  }
}
@media only screen and (min-width: 1400px) {
  .headerMenu .column {
    padding: 0 5px;
  }
}
@media only screen and (min-width: 1100px) {
  .menu-button, .menu-button:hover {
    padding: 0 15px;
  }
  .menu-button-link {
    padding: 0 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/desktop/widget/header/menu.vue